// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/oil_card/css/oil_style.css
// module id = XW1+
// module chunks = 147